import { useState, useEffect } from "react"
import { wrapBatterZoneGraphData, wrapZoneGraphData } from "../../Utils/ZonePRUtils"

export function ZoneChart({title='', type, zone}) {

  const[data, setData] = useState({
      ozone: [0, 0, 0, 0], 
      ozonePR: [0, 0, 0, 0], 
      zone: [0, 0, 0, 0, 0, 0, 0, 0, 0], 
      zonePR: [0, 0, 0, 0, 0, 0, 0, 0, 0]
  })


  useEffect(()=>{
      if(zone !== null && zone !== undefined){
        setData(wrapBatterZoneGraphData(type, zone))
      }
  },[zone])


  function setZoneItem(index, val, pr) {
      var color = parseInt(pr/10)
      if(isNaN(color))
          color = 1
          else color += 1
      return <div className={"zone"+index + " zone_color"+Math.min(color, 10)} >{val? val[0]==='0'? val.slice(1,6):val:'.000'}</div>
  }

  return (
      <div className="chart_zone">
          <div className="chart_zone_title">{title}</div>
          <div className="chart_zone_block">
              {
                  data.ozone.map((v, z)=>{
                      return setZoneItem((parseInt(z)+1), v, data.ozonePR[z])
                  })
              }
              <div className="zone_middle">
              {
                  data.zone.map((v, z)=>{
                      return setZoneItem((parseInt(z)+5), v, data.zonePR[z])
                  })
              }
              </div>
          </div>
      </div>
  )
}

export function ZoneChart2({title='', type, zone, nullValue=0, percentage=false}) {

    const[data, setData] = useState({
        ozone: [0, 0, 0, 0], 
        ozonePR: ['', '', '', ''], 
        zone: [0, 0, 0, 0, 0, 0, 0, 0, 0], 
        zonePR: ['', '', '', '', '', '', '', '', '']
    })
  
    useEffect(()=>{
        if(zone !== null && zone !== undefined){
          setData(wrapZoneGraphData(type, zone))
        }
    },[zone])
  
  
    function setZoneItem(index, val, pr) {
        return <div className={"zone"+index + " "+pr} >{val? percentage? parseInt(val)+'%':val:nullValue}</div>
    }
  
    return (
        <div className="chart_zone">
            <div className="chart_zone_title">{title}</div>
            <div className="chart_zone_block">
                {
                    data.ozone.map((v, z)=>{
                        return setZoneItem((parseInt(z)+1), v, data.ozonePR[z])
                    })
                }
                <div className="zone_middle">
                {
                    data.zone.map((v, z)=>{
                        return setZoneItem((parseInt(z)+5), v, data.zonePR[z])
                    })
                }
                </div>
            </div>
        </div>
    )
  }